const BlockEmbed = Quill.import('blots/block/embed');
import Quill from 'quill';

class DividerBlot extends BlockEmbed {
  static blotName = 'divider';
  static tagName = 'hr';
}

Quill.register(DividerBlot);
